import { useState } from 'react';

export const useSubjectSelector = () => {
  const [open, setOpen] = useState<boolean>(false);
  const toggleOpen = () => setOpen(!open);
  const close = () => setOpen(false);
  return {
    open,
    toggleOpen,
    close,
  };
};
